<template>
  <!-- 添加店铺默认模板 -->
  <el-dialog
    title="修改数量单位"
    center
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel">
    <div class="y-f y-f-a y-f-js y-f-wrap">
      <div v-for="(item,idx) in unitList" :key="idx" class="y-f y-f-a y-w-150 y-mb-20" :class="{'custom-radio y-w-300': item=='自定义'}">
        <el-radio v-model="checkedUnit" :label="item" >{{item}}</el-radio>
        <el-input v-if="item=='自定义'" v-model="customUnit" class="y-w-200" placeholder="请输入" :maxlength="10" auto-complete="off"></el-input>
      </div>
    </div>
    <div slot="footer">
      <el-button class="y-w-100" size="medium" @click="cancel">取消</el-button>
      <el-button type="primary" class="y-w-100" size="medium" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ['visible', 'unit'],
  data() {
    return {
      unitList: ['件', '个', '包', '台', '份', '只', '条', '盒', '双', '自定义'],
      checkedUnit: '',
      customUnit: ''
    }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false);
    },
    confirm() {
      let paramItem = this.checkedUnit;
      if (this.checkedUnit == '自定义') {
        if (!this.customUnit) {
          this.$message.error('自定义单位不能为空。')
          return false;
        } else if (this.customUnit&&this.customUnit.length > 10) {
          this.$message.error('自定义单位不能超过10个字符。');
          return false;
        }
        paramItem = this.customUnit;
      }
      console.log('paramItem--', paramItem);
      this.$emit('saveUnit', paramItem)
      // 点击确定
      this.cancel();
    },
  },
  mounted() {
    let list = this.unitList.filter(o => { return o == this.unit; });
    this.checkedUnit = list.length ? list[0] : '自定义';
    if (this.unit && !list.length) {
      this.customUnit = this.unit || '';
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .custom-radio .el-radio {
  margin-right: 10px;
}
</style>
